<template>
  <div>
    <DataTables
      :table-data="tableData"
      :table-label="tableLabel"
      :config="config"
      @searchTable="searchClick(param)"
      @dateChangeEvent="searchClick(param)">
    </DataTables>
  </div>

</template>

<script>
import DataTables from '../../../components/pageComponent/DataTables'
export default {
  name: 'dept',
  components: {
    DataTables
  },
  props: {
    rowdata: {
      type: Object, //类型
      required: true //默认值
    }
  },
  data() {
    return {
      param: '',
      //搜索时触发true
      // searchFlag: false,
      // 搜索条件对象
      searchObj: {},
      config: {
        fixed: true,
        sizes: [15, 25, 35],
        dataTotalCount: 0,
        pageSize: 15,
        currentPage: 1,
        loading: true,
        searchTables: true,
        height: '30vh',
        indexWidth: '85%'
      },
      tableData: [],
      tableLabel: [
        {
          label: '流程启动时间',
          prop: 'startdate',
          search: '',
          isShow: 'false'
        },
        {
          label: '流程完成时间',
          prop: 'enddate',
          search: ''
        },
        {
          label: '正在流程中文档',
          prop: 'workingcount',
          search: ''
        },
        {
          label: '完成流程文档',
          prop: 'completecount',
          search: ''
        },
        {
          label: '节点名称',
          prop: 'nodename',
          search: ''
        },
        {
          label: '节点顺序',
          prop: 'nodeorder',
          search: '',
          isShow: 'false'
        },
        {
          label: '节点执行人',
          prop: 'nodeuser',
          search: ''
        },
        {
          label: '节点开始时间',
          prop: 'nodesdate',
          search: '',
          type: 'Date'
        },
        {
          label: '节点结束时间',
          prop: 'nodeedate',
          search: '',
          type: 'Date'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.config.loading = true
      const data = {
        subOrderNo: this.rowdata.subOrderNo
      }
      this.$post('/fesback/taskState/queryInnerid.z', data).then(response => {
        //关闭遮罩层
        this.config.loading = false
        if (response === '') {
          this.tableData = []
        } else {
          this.tableData = (this.tableData).concat(response)
        }
      }).catch(function(error) {
        console.log(error)
        //关闭遮罩层
        this.config.loading = false
      })
    }
  }
}

</script>

<style scoped>

</style>
